<template>
    <div class="muven-filter-information" v-if="filterSubmitted.isFilterFilled()">
        <p v-for="(prop, index) in filterProperties" 
            :key="index"
            v-show="shouldShowInfo(filterSubmitted, prop)">
            <span class="muven-filter-information-label">{{prop.label}}: </span>
            <span>{{getFilterSubmittedInfo(filterSubmitted, prop)}}</span>
        </p>
    </div>
</template>

<script>
import { dateFilter } from '@/utils/filters/DateTimeFilter'

export default {
    name: 'FilterInformationCmp',
    props: {
        filterSubmitted: {
            type: Object,
            default: new Object(),
        },

        // `filterProperties` and its possible object properties
        // type: string, list or daterange
        // label: left side naming for the information
        // property: which prop to access in given object
        // propertyInList: which prop to access in given object in a list
        filterProperties: {
            type: Array,
            default: [],
        },
    },
    methods: {
        getFilterSubmittedInfo(filterSubmitted, prop) {
            switch (prop.type) {
                case 'string':
                    return filterSubmitted[prop.property]
                
                case 'list':
                    const tt = filterSubmitted[prop.property];
                    if (!tt) {
                        return ""
                    }
                    return tt.map((p) => p[prop.propertyInList]).join().replace(/,/g, ', ')

                case 'enumwrapped':
                    if (!filterSubmitted[prop.property]) {
                        return ""
                    }

                    return filterSubmitted[prop.property].description

                case 'booleanwrapped':
                    if (!filterSubmitted[prop.property]) {
                        return ""
                    }

                    return filterSubmitted[prop.property].description


                case 'daterange':
                    if (!filterSubmitted[prop.property] || (!filterSubmitted[prop.property].start && !filterSubmitted[prop.property].end)) {
                        return ""
                    }

                    if (filterSubmitted[prop.property].start && filterSubmitted[prop.property].end) {
                        return `${dateFilter(filterSubmitted[prop.property].start)} até ${dateFilter(filterSubmitted[prop.property].end)}`
                    }

                    if (filterSubmitted[prop.property].start) {
                        return `Começando em ${dateFilter(filterSubmitted[prop.property].start)}`
                    }

                    if (filterSubmitted[prop.property].end) {
                        return `Até ${dateFilter(filterSubmitted[prop.property].end)}`
                    }

                    return false
                default:
                    throw new Error(`Unknown filter type: ${prop.type}`)
            }
        },
        shouldShowInfo(filterSubmitted, prop) {
            switch (prop.type) {
                case 'string':
                    return !!filterSubmitted[prop.property].length
                
                case 'list':
                    const tt = filterSubmitted[prop.property];
                    if (!tt) {
                        return false
                    }
                    return !!tt.length

                case 'enumwrapped':
                    if (!filterSubmitted[prop.property]) {
                        return false
                    }
                    return !!filterSubmitted[prop.property].description.length

                case 'booleanwrapped':
                    if (!filterSubmitted[prop.property]) {
                        return false
                    }

                    return !!filterSubmitted[prop.property].description.length

                case 'daterange':
                    if (!filterSubmitted[prop.property]) {
                        return false
                    }

                    return !!filterSubmitted[prop.property].start || !!filterSubmitted[prop.property].end

                default:
                    throw new Error(`Unknown filter type: ${prop.type}`)
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.muven-filter-information {
    padding: 5px 10px;
    border: 1px solid color-mix(in srgb, var(--brand-soft) 50%, transparent);
    border-left: 3px solid var(--brand-soft);
    background-color: color-mix(in srgb, var(--brand-soft) 5%, transparent);
    margin-bottom: 16px;
    border-radius: 2px;

    .muven-filter-information-label {
        text-transform: uppercase;
        font-weight: 600;
        color: var(--text-muted);
        letter-spacing: 1px;
    }

    p {
        margin-bottom: 0;
    }
}
</style>
